/**
 * OrderList Component
 */

import { ListItemAnimations } from '../../../../utils/animation';
import { getFormattedDateFromGraphQL, isPastDue } from '../../../../utils/date';
import './order-list.scss';

import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { connect } from 'react-redux';
import { VelocityTransitionGroup } from 'velocity-react';

import OrderButton from './OrderButton';

interface IOwnProps {
  orders: GQL.IOrder[];
  onSelectOrder: (invoiceNumber: string) => void;
}

type OrderListProps = IOwnProps & IDispatchProps;

const OrderListAnimation = ListItemAnimations(128);
const classes = new BEM('order-list');

class OrderList extends React.Component<OrderListProps, {}> {
  render() {
    return (
      <div {...classes('wrapper')}>
        <VelocityTransitionGroup
          component="ul"
          enter={{ animation: OrderListAnimation.In, stagger: 150 }}
          leave={{ animation: OrderListAnimation.Out }}
          {...classes()}
        >
        {this.props.orders.map((order, index) => {
          /* tslint:disable-next-line */
          const title = `#${order.invoice_number} | ${order.project_details!.brand} • ${order.project_details!.product}`;
          const subtitle = order.order_date ? getFormattedDateFromGraphQL(order.order_date) : '';
          return (
            <li key={order.id} {...classes('item')}>
              <OrderButton
                id={`${order.invoice_number}`}
                title={title}
                subtitle={subtitle}
                onSelect={() => this.props.onSelectOrder(`${order.invoice_number}`)}
                isPastDue={isPastDue(order.payment_due_date) && order.payment_status !== 'PaymentReceived'}
              />
            </li>
          );
        })}
        </VelocityTransitionGroup>
      </div>
    );
  }
}

const ConnectedOrderList = connect()(OrderList);

export default ConnectedOrderList;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/account/Orders/OrderList.tsx